/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptorService } from './interceptor.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbCardModule,
  NbButtonModule,
} from '@nebular/theme';
import { environment } from '../environments/environment';

import { DialogNamePromptComponent } from './components/dialog-name-prompt/dialog-name-prompt.component';
import { ColorPickerDialogComponent } from './components/edit-component-dialog/color-picker-dialog/color-picker-dialog.component';
import { SetupComponent } from './setup.component';
import { OktaCallbackComponent } from './callback.component';
import {
  OKTA_CONFIG,
  OktaAuthModule,
} from '@okta/okta-angular';


const oktaConfig = {
  issuer: 'https://login.storydoc.com/oauth2/aus2myy2r1tMoOYFs5d7',
  clientId: environment.oktaAppId,
  redirectUri: window.location.origin + '/implicit/callback',
  scopes: ['openid', 'profile', 'email'],
  pkce: true
}

@NgModule({
  entryComponents: [
    DialogNamePromptComponent,
    ColorPickerDialogComponent
  ],
  declarations: [AppComponent, DialogNamePromptComponent, OktaCallbackComponent, SetupComponent, ColorPickerDialogComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,

    ThemeModule.forRoot(),

    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    NbCardModule,
    NbButtonModule,
    OktaAuthModule,
  ],
  providers: [
    { provide: OKTA_CONFIG, useValue: oktaConfig },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
